import img1 from "./card-img/product-img-1.jpg";
import img2 from "./card-img/product-img-2.jpg";
import img3 from "./card-img/product-img-3.jpg";
import img4 from "./card-img/product-img-4.jpg";
import img5 from "./card-img/product-img-5.jpg";
import img6 from "./card-img/product-img-6.jpg";
import img7 from "./card-img/product-img-7.jpg";
import img8 from "./card-img/product-img-8.jpg";
import img9 from "./card-img/product-img-9.jpg";
import img10 from "./card-img/product-img-10.jpg";
import img11 from "./card-img/product-img-1.jpg";
import img12 from "./card-img/product-img-2.jpg";

const Datastat = [
  {
    id: 1,
    imgo: img1,
    info: "Joystick Conjurica ea magna eiusmod esse cupt anim aliquip",
    finalPrice: "$117.79",
    Beforeo: "$124.55",
  },
  {
    id: 2,
    imgo: img2,
    info: "Speeker Geeky ipsum esse repreh est consequat",
    finalPrice: "$115.79",
    Beforeo: "$121.00",
  },
  {
    id: 3,
    imgo: img3,
    info: "White PlayStation Geeky ipsum esse repreh est consequat",
    finalPrice: "$115.79",
    Beforeo: "$121.00",
  },
  {
    id: 4,
    imgo: img4,
    info: "Labtop Geeky ipsum esse repreh est consequat",
    finalPrice: "$115.79",
    Beforeo: "$121.00",
  },
  {
    id: 5,
    imgo: img5,
    info: "Mobile Geeky ipsum esse repreh est consequat",
    finalPrice: "$115.79",
    Beforeo: "$121.00",
  },
  {
    id: 6,
    imgo: img6,
    info: "Blue Fan Geeky ipsum esse repreh est consequat",
    finalPrice: "$115.79",
    Beforeo: "$121.00",
  },
  {
    id: 7,
    imgo: img7,
    info: "Toster Geeky ipsum esse repreh est consequat",
    finalPrice: "$115.79",
    Beforeo: "$121.00",
  },
  {
    id: 8,
    imgo: img8,
    info: "White Airpod Geeky ipsum esse repreh est consequat",
    finalPrice: "$115.79",
    Beforeo: "$121.00",
  },
  {
    id: 9,
    imgo: img9,
    info: "Headphone Geeky ipsum esse repreh est consequat",
    finalPrice: "$115.79",
    Beforeo: "$121.00",
  },
  {
    id: 10,
    imgo: img10,
    info: "Black Play staion Geeky ipsum esse repreh est consequat",
    finalPrice: "$115.79",
    Beforeo: "$121.00",
  },
  {
    id: 11,
    imgo: img11,
    info: "Joystick Geeky ipsum esse repreh est consequat",
    finalPrice: "$115.79",
    Beforeo: "$121.00",
  },
  {
    id: 12,
    imgo: img12,
    info: "Speaker Geeky ipsum esse repreh est consequat",
    finalPrice: "$115.79",
    Beforeo: "$121.00",
  },
];

export default Datastat;
